import { gql } from '@generated/gql';

gql(`
    fragment QualifiedDiscountFragment on QualifiedDiscount {
      id
      qualificationMessage
      appliesAfter
      discountLengthMonths
      targetQuoteId
      discountedPrice {
        value
        currency
      }
    }
`);

gql(`
  fragment MobileTariffFragment on MobileTariff {
    id
    productId
    monthlyCost {
      value
      currency
    }
    name
    selected
    tariffType
    discounts {
      ...QualifiedDiscountFragment
    }
  }
`);

gql(`
  fragment MobileSimFragment on Sim {
    id
    settings {
      porting {
        ... on PortingPAC {
          mobileNumber
          pac
        }
        ... on PortingSTAC {
          stac
          mobileNumber
        }
      }
      keepNumber
      cancelPreviousContract
      budgetControl
    }
    selectedTariff {
      ...MobileTariffFragment
    }
  }
`);

gql(`
    fragment BasketMobileFragment on BasketMobile {
      totalMonthlyCost {
        value
        currency
      }
      sims {
        ...MobileSimFragment
      }
      selectedSimCount
      discounts {
        ...QualifiedDiscountFragment
      }
    }
`);

const getMobileTariffs = gql(`
  query GetMobileTariffs($basketId: ID!, $selection: SimSelectionInput!) {
    mobileTariffs(basketId: $basketId, selection: $selection) {
      tariffs {
        ...MobileTariffFragment
      }
      discounts {
        ...QualifiedDiscountFragment
      }
    }
  }
`);

const selectMobileMutation = gql(`
  mutation SelectMobile($basketId: ID!, $selection: MobileSelectionInput!) {
    selectMobile(basketId: $basketId, selection: $selection) {
      ...BundleBasket
    }
  }
`);

const deselectMobileMutation = gql(`
  mutation DeselectMobile($basketId: ID!) {
    deselectMobile(basketId: $basketId) {
      ...BundleBasket
    }
  }
`);

export { getMobileTariffs, selectMobileMutation, deselectMobileMutation };
